// Presentation only: identifiers and stored routing remain Python-owned.
export function controlDisplayName(record: { name: string; displayName?: string; editableValue?: boolean }): string {
  if (/^(unknown|unresolved)(_|$)/i.test(record.name)) return 'Unknown Control';
  if (record.displayName) return record.displayName;
  if (record.editableValue === false) return 'Unknown Control';
  return record.name.split('_').map(word => ['vc', 'midi'].includes(word.toLowerCase()) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}
